import axios from 'axios'

export let fetchMe = async () => {
  let res = await axios.get('user/me')

  return res.data
}

export let fetchManager = async () => {
  let res = await axios.get('user/manager')

  return res.data
}

export let fetchBudgetHistory = async () => {
  let res = await axios.get('user/budget/history')

  return res.data
}

export let fetchRubrics = async () => {
  let res = await axios.get('user/subscribe/rubrics')

  return res.data
}

export let saveSubscription = async (data) => {
  await axios.post('user/subscribe', data)
}

export let removeAccount = async (data) => {
  const response = await axios.post('personal/removeAccount', data)
  return response.data
}




// WEBPACK FOOTER //
// ./src/api/user.js